module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/img-photo-studio-kimono-costume-e01afc67475d1c9ddbf231638aaeeae7.png";